import { CSAT_TOOL_GENERAL, CSAT_TOOL_ROUTES } from './constants'

// Resolve which tool the user is currently in from a pathname, defaulting to the 'general'
// sentinel. Pure and router-free so it can run from anywhere (modal, action) and be unit-tested.
export const resolveCsatTool = (pathname = '') => {
  const segments = String(pathname).toLowerCase().split('/').filter(Boolean)
  const match = CSAT_TOOL_ROUTES.find(({ segment }) => segments.includes(segment))
  return match ? match.tool : CSAT_TOOL_GENERAL
}

export const getCurrentCsatTool = () => {
  const pathname = typeof window !== 'undefined' && window.location ? window.location.pathname : ''
  return resolveCsatTool(pathname)
}
